exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inp{width:100%;height:35px;border-radius:7px;border:none;color:grey;text-transform:uppercase;padding:15px}", ""]);

// exports
